import * as tslib_1 from "tslib";
import { MatMenuTrigger } from '@angular/material';
import { Messenger } from './services/messenger';
import { Router } from '@angular/router';
import { Data } from './services/data';
import { Sync } from './services/sync';
var TIMEOUT = 3000;
var AppComponent = /** @class */ (function () {
    function AppComponent(router, messenger, data, sync) {
        this.router = router;
        this.messenger = messenger;
        this.data = data;
        this.sync = sync;
        this.title = 'healthTracker';
        this.snackCount = 0;
    }
    AppComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var hasBeenSeeded;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.data.hasBeenSeeded()];
                    case 1:
                        hasBeenSeeded = _a.sent();
                        if (!hasBeenSeeded) {
                            this.messenger.send('Establishing Database', false);
                            try {
                                this.router.navigate(['seed']);
                            }
                            catch (e) {
                                console.error('Failed to navigate to seed', e);
                                throw e;
                            }
                        }
                        this.data.syncableChanges.subscribe(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.sync.triggerSync()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype.ngAfterContentInit = function () {
    };
    AppComponent.prototype.download = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, json, b, url, loweredUA, link;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.data.getAllUserData()];
                    case 1:
                        data = _a.sent();
                        json = JSON.stringify(data);
                        b = new Blob([json], { type: 'application/json' });
                        url = URL.createObjectURL(b);
                        loweredUA = window.navigator.userAgent.toLocaleLowerCase();
                        if (loweredUA.indexOf('ios') > -1
                            || loweredUA.indexOf('android') > -1) {
                            window.open(url, '_blank');
                        }
                        else {
                            link = document.createElement('a');
                            link.setAttribute('href', url);
                            link.setAttribute('download', 'healthTrackerHistory.json');
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            URL.revokeObjectURL(url);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype.goToSyncSetup = function () {
        this.router.navigateByUrl('/setup-sync');
    };
    return AppComponent;
}());
export { AppComponent };
